// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3A661","contentTable":"styles_contentTable__22MaD","header":"styles_header__2kOg7","columnsA":"styles_columnsA__1ysT0","columnsB":"styles_columnsB__3dTbf"};